interface ICoverPageProps {
  title: string | undefined;
  startDate: string;
  endDate: string;
}

const CoverPage: React.FC<ICoverPageProps> = ({ title, startDate, endDate }) => (
  <div
    id="cover-page"
    className="cover-page mb-4 flex h-[20vh] flex-col items-center justify-center"
  >
    <h1 className="text-center text-4xl font-bold">{title}</h1>
    <h3 className="mt-4 text-lg text-gray-600">{`${startDate} & ${endDate}`}</h3>
  </div>
);

export default CoverPage;
